export const EMAIL_ATTACHMENT_PATIENT_COLLECTION_KEYS = [
  'data',
  'received_data',
  'assigned_data',
  'referred_data',
];

const ROOT_FIELD_BY_METADATA_FIELD = {
  patient_name: ['patientName'],
  patient_first_name: ['patientFirstName'],
  patient_middle_name: ['patientMiddleName'],
  patient_last_name: ['patientLastName'],
  patient_dob: ['patientDOB'],
  patient_phone_number: ['patientPhoneNumber'],
  document_title: ['documentTitle', 'fileTitle'],
  document_category: ['documentCategory'],
  privacy_level: ['privacyLevel'],
  referral_note: ['referralNote'],
  referring_provider: ['referringProvider'],
  provider_office: ['referringProviderOffice', 'providerOffice'],
};

export const CANONICAL_PATIENT_METADATA_KEYS = Object.keys(ROOT_FIELD_BY_METADATA_FIELD);

export const patientMetadataFromResponse = (response) => {
  const metadata = response?.data?.patient_metadata;
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return null;
  if (!CANONICAL_PATIENT_METADATA_KEYS.every(
    (field) => Object.prototype.hasOwnProperty.call(metadata, field),
  )) return null;

  return Object.fromEntries(
    CANONICAL_PATIENT_METADATA_KEYS.map((field) => [field, metadata[field]]),
  );
};

export const teamsResponseFromPatientUpdate = (response) => {
  const responseData = response?.data;
  if (!responseData || typeof responseData !== 'object') return null;
  if (!Object.prototype.hasOwnProperty.call(responseData, 'send_token')) return null;

  return {
    send_token: responseData.send_token,
    team: responseData.team,
  };
};

export const patchCanonicalPatientMetadata = (
  record,
  fileToken,
  canonicalMetadata,
) => {
  if (!fileToken) return record;
  return record?.file_token === fileToken
    ? { ...record, ...canonicalMetadata }
    : record;
};

export const canonicalPatientRootFields = (canonicalMetadata) => (
  Object.entries(ROOT_FIELD_BY_METADATA_FIELD).reduce((fields, [metadataField, rootFields]) => {
    if (!Object.prototype.hasOwnProperty.call(canonicalMetadata, metadataField)) return fields;
    return rootFields.reduce((nextFields, rootField) => ({
      ...nextFields,
      [rootField]: canonicalMetadata[metadataField],
    }), fields);
  }, {})
);
